var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.75C11.9403 13.75 12.5 13.1904 12.5 12.5C12.5 11.8096 11.9403 11.25 11.25 11.25C10.5596 11.25 10 11.8096 10 12.5C10 13.1904 10.5596 13.75 11.25 13.75Z",
    fill: "#FB6340"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18.75C10.5596 18.75 10 19.3096 10 20C10 20.6904 10.5596 21.25 11.25 21.25H18.75C19.4404 21.25 20 20.6904 20 20C20 19.3096 19.4404 18.75 18.75 18.75H11.25Z",
    fill: "#FB6340"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.5C20 13.1904 19.4404 13.75 18.75 13.75C18.0596 13.75 17.5 13.1904 17.5 12.5C17.5 11.8096 18.0596 11.25 18.75 11.25C19.4404 11.25 20 11.8096 20 12.5Z",
    fill: "#FB6340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5 15C27.5 21.9035 21.9035 27.5 15 27.5C8.09644 27.5 2.5 21.9035 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9035 2.5 27.5 8.09644 27.5 15ZM25 15C25 20.5229 20.5229 25 15 25C9.47715 25 5 20.5229 5 15C5 9.47715 9.47715 5 15 5C20.5229 5 25 9.47715 25 15Z",
    fill: "#FB6340"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.0bd3d568f77845817042b4f0935fbb33.svg";
export { ForwardRef as ReactComponent };